export default __webpack_public_path__ + "static/media/mic(white).11f435b7.svg";